import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Calendar, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/Reveal";
import { articles, images } from "@/mock/mock";

export default function InsightsPreview() {
  const items = articles.slice(0, 3);
  return (
    <section className="relative py-24 border-t border-white/10 bg-brand-navy2/40">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">Insights</span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-white">
              Latest from our security team
            </h2>
          </div>
          <Button asChild variant="outline" className="group rounded-full border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white w-fit">
            <Link to="/insights">View all articles <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>
          </Button>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 80}>
              <Link to={`/insights/${a.slug}`} className="group block h-full rounded-2xl border border-white/10 bg-brand-navy2/60 overflow-hidden card-hover">
                <div className="relative h-44 overflow-hidden">
                  <img src={images[a.image]} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-3 left-3 rounded-full bg-white/10 px-3 py-1 text-[11px] font-medium text-brand-lime backdrop-blur">{a.category}</span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-semibold text-white group-hover:text-brand-lime transition-colors flex items-start gap-1">
                    {a.title}
                    <ArrowUpRight className="h-4 w-4 shrink-0 text-brand-lime opacity-0 group-hover:opacity-100 transition-opacity mt-1" />
                  </h3>
                  <div className="mt-4 flex items-center gap-4 text-xs text-slate-400">
                    <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-brand-lime" /> {a.date}</span>
                    <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-brand-lime" /> {a.readTime}</span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
